module.exports = __webpack_public_path__ + "img/hopways-03.36575240.jpeg";